import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from 'react-select';
import cn from 'classnames';
import { calculationTotalPriceNewOrder, changeChangeCashNewOrder, changeInformationNewOrder, changeDeliveryMethodNewOrder, changePaymentNewOrder, changePointNewOrder, setZonesNewOrder, addTagNewOrder, fetchPromocodeHandler } from "../../action/neworder";
import request from "../../action/utils/request";
import { defaultPlatforms, optionsRole, optionsStatus, roleId, urls } from "../../constants/app";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ru from "date-fns/locale/ru";
import moment from "moment";
import { setActiveModalAction } from '../../action';
import { clearHistoryOrders, fetchHistoryOrders } from "../../action/historyOrders";
import { fetchPayments, fetchSources, fetchTags } from "../../action/handbook";
import { checkSorucePromotions, parseNumToFixed } from "../../utils/common";
import { isEmpty } from "lodash";
registerLocale("ru", ru);

const courierStatuses = {
    accepted: 'Принял заказ',
    arrived_to_source: 'Прибыл на место',
    taken: 'Взял заказ',
    arrived_to_destination: 'Прибыл к клиенту',
    finished: 'Заказ доставлен',
};

function DetailNewOrder(props) {
    const { editOrder } = props;
    const filials = useSelector(state => state.handbook.filials);
    const loadingFilials = useSelector(state => state.loaders.filials);
    const loadingFilialsNewOrder = useSelector(state => state.loaders.loadingFilialsNewOrder);
    const loadingHistoryOrders = useSelector(state => state.loaders.historyOrders);
    const loadingPromocode = useSelector(state => state.loaders.orderPromo)
    const neworders = useSelector(state => state.neworders);
    const historyOrders = useSelector(state => state.historyOrders.list);
    const historyHidden = useSelector(state => state.historyOrders.hidden);
    const payments = useSelector(state => state.handbook.payments);
    const tags = useSelector(state => state.handbook.tags);
    const sources = useSelector(state => state.handbook.sources);
    const idPointCC = useSelector(state => state.settings.init.idPointCC);
    const idPointRobovoice = useSelector(state => state.settings.init.idPointRobovoice);
    const user = useSelector(state => state.user.info);

    const dispatch = useDispatch();

    const [inputChangeCash, setInputChangeCash] = useState('');
    const [preOrder, setPreOrder] = useState(false);
    const [openInfoPoint, setOpenInfoPoint] = useState(false)
    const [openPromotionDescription, setOpenPromotionDescription] = useState(false)

    useEffect(() => {
        dispatch(fetchPayments(true));
        dispatch(fetchTags(true, true));
        dispatch(fetchSources(true, true))
    }, [dispatch]);

    useEffect(() => {
        if (neworders.phone && String(neworders.phone).length === 11) dispatch(fetchHistoryOrders(+neworders.phone))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [neworders.phone, dispatch]);

    const platforms = sources && sources.length > 0 
    ? sources.map((source) => ({ label: source.name, value: source.value }))
    : defaultPlatforms;

    useEffect(() => {
        setInputChangeCash('');
        if(neworders.visible_datetime)
            setPreOrder(true);
    }, [neworders.changeCash, neworders.visible_datetime, dispatch])

    useEffect(() => {
        setOpenInfoPoint(false);
        setOpenPromotionDescription(false);
        if (neworders.point) {
            const fetchZones = (id) => {
                return request({ method: 'get', url: `${urls.zone}`, params: { 'point.id': id, getCrm: true } })
                .then((response) => {
                    dispatch(setZonesNewOrder(response));
                    return response;
                })
                .catch(error => {
                    dispatch(setZonesNewOrder(null));
                    return null
                });
            }

            if (neworders.point.id) {
                fetchZones(neworders.point.id);
            } else {
                fetchZones(neworders.point);
            }
        }
    }, [dispatch, neworders.point])

    useEffect(() => {
        if (!neworders.point && historyOrders.length > 0) {
            if (historyOrders[0] && historyOrders[0].point) handleChangePoint(historyOrders[0].point.id || historyOrders[0].point);
            if (historyOrders[0].zone && historyOrders[0].zone.point) handleChangePoint(historyOrders[0].zone.point.id || historyOrders[0].zone.point);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [historyOrders])

    useEffect(() => {
        if (!editOrder) {
            if ([roleId.operator, roleId.coordinator].includes(user.role.id)){
                dispatch(changeDeliveryMethodNewOrder('delivery'));
            }      
        }
    }, [dispatch, editOrder, user.role.id]);   

    const handleChangePoint = (id) => {
        dispatch(changePointNewOrder(null, null));

        if(neworders.delivertPrice > 0)
            dispatch(calculationTotalPriceNewOrder());

        dispatch(setZonesNewOrder(null));
        dispatch({ type: 'SET_LOADER', field: 'loadingFilialsNewOrder', value: true });
        return request({ method: 'get', url: `${urls.filials}/${id}` })
        .then((response) => {
            dispatch({ type: 'SET_LOADER', field: 'loadingFilialsNewOrder', value: false });
            dispatch(changePointNewOrder(response, response.city));
            return response;
        })
        .catch(error => {
            dispatch({ type: 'SET_LOADER', field: 'loadingFilialsNewOrder', value: false });
            return null
        });
    }

    const onOpenModal = (field) => (e) => {
        e.stopPropagation();
        dispatch(setActiveModalAction({ field: field, value: true }));
    };

    const onOpenClient = (id) => (e) => {
        e.stopPropagation();
        dispatch(setActiveModalAction({ field: 'client', value: id }));
    }    

    const handleInputChangeCash = (e) => {
        if(e.target.value <= 999999 && e.target.value > 0)
            return setInputChangeCash(parseFloat(e.target.value).toFixed(0))

        if(e.target.value > 999999)
            return setInputChangeCash(999999)

        if(e.target.value <= 0)
            return setInputChangeCash('')
    };

    const renderAdress = (item) => {
        return `${item.city.name ? item.city.name : neworders.city ? neworders.city.name : '---'}, ${item.street}, ${item.house}`;
    };

    const getOrderPointId = (item) => {
        let pointId;

        if (item.point) {
            if (typeof item.point === 'object' &&  item.point.id) {
                pointId = item.point.id;
            } else {
                pointId = item.point;
            }
        } else if (item.zone && item.zone.point) {
            if (typeof item.zone.point === 'object' &&  item.zone.point.id) {
                pointId = item.zone.point.id;
            } else {
                pointId = item.zone.point;
            }
        }

        return pointId;
    }

    const renderSelectPoint = (item) => {
        if (!item.point && !item.zone) return null;
        if(item.zone && !item.zone.point.id && !filials.find((el) => el.id === item.zone.point)) return null;
        const pointId = getOrderPointId(item);
        
        if (!pointId) return null;
        const entity = filials.find((fil) => fil.id === pointId);
        if (isEmpty(entity)) return null;

        const getCityName = () => {
            if (item && item.city && item.city.name) return item.city.name;
            if (neworders && neworders.city && neworders.city.name) return neworders.city.name;
            if (entity && entity.city && entity.city.name) return entity.city.name;
            return '-';
        }

        return ({
            value: entity.id,
            label: `${getCityName()}, ${entity.street}, ${entity.house}`
        });         
    }

    useEffect(() => {
        if (!neworders.point && user && user.points && user.points.length === 1) handleChangePoint(user.points[0].id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    const pointValue = renderSelectPoint(neworders);
    const getStatusPay = () => {
        if (!neworders.paymentId) return 'ЮКасса, не оплачен';
        let paymentData = neworders.paymentData ? JSON.parse(neworders.paymentData) : null;

        if (!neworders.paymentData) return 'ЮКасса, не оплачен';
        if (!paymentData) return 'ЮКасса, не оплачен';
        if (paymentData.status === 'pending') return 'ЮКасса, ожидает оплаты';
        if (paymentData.status === 'succeeded') return 'ЮКасса, оплачен';
        if (paymentData.status === 'refundPending') return 'ЮКасса, выполняется возврат средств';
        if (paymentData.status === 'refund') return 'ЮКасса, возврат средств выполнен';

        if (paymentData.status === 'canceled') {
            if(paymentData.cancellation_details && paymentData.cancellation_details.party) {
                const initiator = paymentData.cancellation_details.party === 'yoo_money' ? 'ЮКасса' : 'участник процесса';
                return `ЮКасса, возврат средств отменен, инициатор ${initiator}`;
            }
            return 'ЮКасса, возврат средств отменен';
        }

        if (paymentData.error && typeof paymentData.error === 'string') return `Юкасса, ${paymentData.error}`;
        
        return `ЮКасса, cтатус не определен`;
    }

     const renderAuthorRole = (role) => {
        if (role === roleId.admin) return 'Администратор';
        const title = optionsRole.find((item) => item.value === role);
        if (title && title.label) return title.label;
        return 'Не найдена';
    }

    const renderSource = (item) => {
        const getSource = () => {
            if (item.source === 'k-porogu') return 'k-porogu';
            if (item.aggData && item.aggData.platform) {
                const platform = platforms.find((source) => source.value === item.aggData.platform);
                if (platform) return platform.label;
                return 'Источник не определен';
            }
            if (item.source === 'crm')  return 'crm';
            if (item.isSite) return 'Сайт';
            return 'Приложение'
        }

        return (
            <div className="neworder_detail_information">
                <span>{getSource() === 'crm' ? 'Роль автора:' : 'Источник:'}</span>  
                <span>{getSource() === 'crm' ? renderAuthorRole(neworders.authorRole) : getSource()}</span>
            </div>
        );
    }

    const fetchPromocode = () => {
        const { promocodeName, deliveryMethod, totalPrice } = neworders;
        const city = neworders.city ? neworders.city : (neworders.point && neworders.point.city) ? neworders.point.city : null;
        
        const data = {
            promocode: promocodeName,
            city,
            deliveryMethod,
            totalPrice,
            source: checkSorucePromotions(user.role.id),
        }

        dispatch(fetchPromocodeHandler(data))
    }

    const renderTypeDeliveryMethod = (item) => {
        if (item.aggData && item.aggData.discriminator === "yandex")
            return (
                <div className="neworder_detail_information">
                    <span>Тип заказа:</span>
                    <button
                    className='neworder_detail_deliverymethod_button agg actived'
                    >
                        {`Курьер ${item.aggData.platform === 'YE' ? 'ЯЕ' : 'ДК'}`}
                    </button>
                </div>
            );
        
        return (
            <div className="neworder_detail_information">
                <span>Тип заказа:</span>  
                <div style={{display: 'flex'}}>
                    <button
                    className={`neworder_detail_deliverymethod_button delivery ${neworders.deliveryMethod === 'delivery' ? 'actived' : ''}`}
                    onClick={(() => {
                        if(neworders.deliveryMethod !== 'delivery')
                            dispatch(changeDeliveryMethodNewOrder('delivery'));
                    })}
                    >
                        Доставка
                    </button>
                    <button
                    className={`neworder_detail_deliverymethod_button own ${neworders.deliveryMethod === 'own' ? 'actived' : ''}`}
                    onClick={(() => {
                        if(neworders.deliveryMethod !== 'own')
                            dispatch(changeDeliveryMethodNewOrder('own'));
                    })}
                    >
                        Вынос
                    </button>                        
                </div>
            </div>
        );
    }

    const renderPromocode = (item) => {
        if (item.sale) return null;
        return (
            <>
                <div className="neworder_detail_input_div">
                    <input 
                        className="form-control neworder"
                        autocomplete="false"
                        placeholder="Промокод"
                        value={neworders.promocodeName ? neworders.promocodeName : ''}
                        onChange={(e) => {
                            dispatch(changeInformationNewOrder('promocodeName', e.target.value));
                        }}
                    />
                    <button 
                        disabled={!neworders.promocodeName || loadingPromocode} 
                        className={cn({ 'btn btn-secondary btn-icon kt-spinner--right kt-spinner--sm kt-spinner--light': true, 'kt-spinner': loadingPromocode })} 
                        style={{ minHeight: '39px', minWidth: '39px' }}
                        onClick={(() => fetchPromocode())}
                    >
                        {!loadingPromocode && <i className="flaticon2-check-mark"/>}
                    </button>
                </div>
            {
                item.errorPromocode && 
                <span style={{ fontSize: '0.7rem', color: 'red'}}>
                    {item.errorPromocode}
                </span>
            }
            </>
        )
    };

    const handleChangePlatform = (item, value) => {
        let data = {...item};

        if (!data || !data.aggData) data.aggData = {};
        data.aggData.platform = value;
        dispatch(changeInformationNewOrder('aggData', data.aggData));
    }

    const renderPlatformSelect = (item) => {
        const platform = (item && item.aggData && item.aggData.platform) ? item.aggData.platform : null;

        return(
            <div className="select_detail_body">
                <div style={{width: '100%'}}>
                <Select
                    isLoading={loadingFilials || loadingFilialsNewOrder}
                    isDisabled={loadingFilials || loadingFilialsNewOrder}
                    closeMenuOnSelect={true}
                    options={platforms}
                    onChange={((e) => handleChangePlatform(item, e.value))}
                    placeholder="Источник"
                    noOptionsMessage={() => 'Нет источников'}
                    value={platforms.find((p) => p.value === platform)}                   
                />
                </div>
            </div>
        );
    };

    const renderAggDataDeliveryInfo = (item) => {
        if (!item.aggData || !item.aggData.deliveryInfo) return null;
        const deliveryInfo = item.aggData.deliveryInfo;
        const courierInfo = item.aggData.courierInfo;

        if (deliveryInfo)
            return (
                <>
                    {deliveryInfo.phoneNumber && 
                    <div className="neworder_detail_information">
                        <span>Тел.</span>  
                        <span>{deliveryInfo.phoneNumber}</span>
                    </div>
                    }
                    {deliveryInfo.additionalPhoneNumbers && 
                    <div className="neworder_detail_information">
                        <span>Доп. тел.</span>  
                        <span>{deliveryInfo.additionalPhoneNumbers}</span>
                    </div>
                    }
                    {deliveryInfo.clientArrivementDate && 
                    <div className="neworder_detail_information">
                        <span>Приготовить к</span>  
                        <span>{moment(deliveryInfo.clientArrivementDate).format('DD.MM.YYYY HH:mm')}</span>
                    </div>
                    }
                    {deliveryInfo.deliveryDate && 
                    <div className="neworder_detail_information">
                        <span>Доставить в</span>  
                        <span>{moment(deliveryInfo.deliveryDate).format('DD.MM.YYYY HH:mm')}</span>
                    </div>
                    }
                    {(!courierInfo || !courierInfo.maxPlaceArrivalTime) && deliveryInfo.courierArrivementDate && 
                    <div className="neworder_detail_information">
                        <span>Курьер прибудет в</span>  
                        <span>{moment(deliveryInfo.courierArrivementDate).format('DD.MM.YYYY HH:mm')}</span>
                    </div>
                    }
                </>
            );
        return null;
    }

    const renderAggDataCourierInfo = (item) => {
        if (!item.aggData || !item.aggData.courierInfo) return null;
        const courierInfo = item.aggData.courierInfo;

        if (courierInfo)
            return (
                <>
                    {courierInfo.courier && courierInfo.courier.name && 
                    <div className="neworder_detail_information">
                        <span>Курьер</span>  
                        <span>{courierInfo.courier.name}</span>
                    </div>
                    }
                    {courierInfo.courier && courierInfo.courier.phone && 
                    <div className="neworder_detail_information">
                        <span>Тел. курьера</span>  
                        <span>{courierInfo.courier.phone}</span>
                    </div>
                    }
                    {courierInfo.courier && courierInfo.courier.status && 
                    <div className="neworder_detail_information">
                        <span>Статус курьера</span>  
                        <span>{courierStatuses[courierInfo.courier.status]}</span>
                    </div>
                    }
                    {courierInfo.maxPlaceArrivalTime &&
                    <div className="neworder_detail_information">
                        <span>Курьер прибудет в</span>  
                        <span>{moment(courierInfo.maxPlaceArrivalTime).format('DD.MM.YYYY HH:mm')}</span>
                    </div>
                    }
                </>
            );
        return null;
    }

    const filteredStatuses = () => {
        const role = user.role.id;
        const point = neworders.point;
        const zone = neworders.zone;
        let currentPoint = null;
        if (point) {
            currentPoint = point;
        } else if (zone) {
            currentPoint = zone.point;
        }
        if (currentPoint && !currentPoint.id) currentPoint = filials.find((fil) => fil.id === currentPoint);
        if (!currentPoint || !currentPoint.atolData || !currentPoint.atolData.activate) return optionsStatus;

        if (role === roleId.admin) return optionsStatus;
        if (role === roleId.courier) return optionsStatus.filter((item) => item.value === 'done');

        const status = neworders.status;
        const deliveryMethod = neworders.deliveryMethod;
        const canceledStatuses = optionsStatus.filter((item) => ['written-off', 'cancel'].includes(item.value));
        let result = optionsStatus;

        if (['written-off', 'cancel', 'done'].includes(status)) {
            result = result.filter((item) => ['written-off', 'cancel', 'done', 'cooked'].includes(item.value));
            return result;
        }

        if (['new', 'processing', 'not-confirmed', 'confirmed', 'deferred'].includes(status)) {
            result = result.filter((item) => {
                if (['new', 'processing', 'not-confirmed', 'confirmed', 'deferred'].includes(item.value)) return true;
                if ([roleId.cashier, roleId.manager, roleId.regionalDirector, roleId.operationDirector, roleId.admin].includes(role) && item.value === 'cook') return true;
                return false;
            });
            return [...result, ...canceledStatuses];
        }

        if (status === 'cook') {
            result = result.filter((item) => {
                if ([roleId.cashier, roleId.manager, roleId.regionalDirector, roleId.operationDirector, roleId.admin].includes(role) && item.value === 'cooked') return true;
                return false;
            });
            return [...result, ...canceledStatuses];
        }

        if (status === 'cooked' && deliveryMethod === 'delivery') {
            result = result.filter((item) => {
                if (item.value === 'delivery' || item.value === 'cooked') return true;
                return false;
            });
            return [...result, ...canceledStatuses];
        }

        if ((status === 'cooked' && deliveryMethod === 'own') || status === 'delivery') {
            result = result.filter((item) => {
                if (deliveryMethod === 'own' && item.value === 'cooked') return true;
                if (status === 'delivery' && item.value === 'delivery') return true;
                if (item.value === 'done') return true;
                return false;
            });
            return [...result, ...canceledStatuses];
        }

        return result;
    }

    const renderStatusSelect = () => {
        if (!editOrder) return null;
        const currentStatus = optionsStatus.find((item) => item.value === neworders.status);
        return (
            <div className="select_detail_body" style={{ marginTop: '5px' }}>
                <div style={{ width: '100%' }}>
                    <Select
                        value={currentStatus || { value: null, label: 'Не определен' }}
                        closeMenuOnSelect={true}
                        options={filteredStatuses()}
                        onChange={(e) => dispatch(changeInformationNewOrder('status', e ? e.value : null))}
                        placeholder="Статус"
                        noOptionsMessage={() => 'Статусы не найдены'}
                    />
                </div>
            </div>
        );
    }

    const renderSelect = () => {
        return(
            <div style={{ display: 'flex', flexDirection: 'column'}}>
            <div className="select_detail_body">
                <div style={{width: '100%'}}>
                <Select
                    isLoading={loadingFilials || loadingFilialsNewOrder}
                    isDisabled={loadingFilials || loadingFilialsNewOrder}
                    closeMenuOnSelect={true}
                    options={filials.filter((item) => !item.hiddenClient || item.id === idPointCC).map((item) => ({ value: item.id, label: renderAdress(item) }))}
                    onChange={((e) => handleChangePoint(e.value))}
                    placeholder="Филиал"
                    noOptionsMessage={() => 'Нет филиалов'}
                    value={pointValue}                    
                />
                </div>
                {neworders.point && 
                    <button 
                    className="order_position_list_inf_button info_point" 
                    onClick={(() => setOpenInfoPoint(!openInfoPoint))} 
                    onBlur={(() => setOpenInfoPoint(false))}>
                        i
                    </button>
                }
            </div>   
                {openInfoPoint &&
                    renderInfoPoint()
                }
            </div>
        )
    }

    const renderPointTime = (point) => {
        let deliveryTime = 60;
        let samTime = 20;
        let deliveryColor = '#000';
        let samColor = '#000';
        if(point) {
            if(point.activate === 'disabledAll')
                return <span style={{color:'red', fontWeight:'600'}}>СТОП</span>;

            if(point.activate === 'disabledDelivery') {
                deliveryTime = 'СТОП';
                deliveryColor = 'red';
            } else {
                deliveryTime = point.minDeliveryTime
                if (deliveryTime < 105 && deliveryTime > 60) deliveryColor = 'orange';
                else if (deliveryTime >= 105) deliveryColor = 'red';
            }

            if(point.activate === 'disabledOwn') {
                samTime = 'СТОП';
                samColor = 'red';
            } else {
                samTime = point.minSamTime
                if (samTime < 50 && samTime > 20) samColor = 'orange'; 
                else if (samTime >= 50) samColor = 'red';
            }

            return <div style={{fontWeight:'600'}}><span style={{color:deliveryColor}}>{deliveryTime}</span>/<span style={{color:samColor}}>{samTime}</span></div>
        }
        return 'Не определено'
    }

    const renderTodayMinTime = (point) => {
        if(neworders.deliveryMethod === 'own') {
            if(point.minSamTime && point.activate !== 'disabledAll' && point.activate !== 'disabledOwn')
                return new Date(new Date().getTime() + parseInt(point.minSamTime) * 60 * 1000);

            return new Date(new Date().getTime() + 20 * 60 * 1000);
        } else {
            if(point.minDeliveryTime && point.activate !== 'disabledAll'  && point.activate !== 'disabledDelivery')
                return new Date(new Date().getTime() + parseInt(point.minDeliveryTime) * 60 * 1000);

            return new Date(new Date().getTime() + 60 * 60 * 1000); 
        }
    }

    const renderClient = () => {
        if (neworders.user) {
            if ([roleId.admin, roleId.directorCC, roleId.marketingSpecialist, roleId.chiefMarketingSpecialist].includes(user.role.id)) {
                return <Link to={`/clients/${neworders.user.id}`}>{neworders.userName}</Link>
            }
            return <span style={{ color: '#5867dd', cursor: 'pointer' }} onClick={onOpenClient(neworders.user.id)}>{neworders.userName}</span>
        }
        return<span>{neworders.userName || '-'}</span>
    }

    const renderDeliveryMethodBlock = () => {
        return(
            <>
                {neworders.point && neworders.point.comment &&
                    <div className="neworder_detail_information">
                        <span style={{fontWeight:'600', color:'#333'}}>{neworders.point.comment}</span>
                    </div>
                }
                {neworders.point && neworders.point.promotion &&
                    <div 
                    className={`neworder_detail_information ${neworders.point.promotionDescription ? ' promotionDescription' : ''}`}
                    tabIndex={1}
                    onClick={(() => {
                        if(neworders.point.promotionDescription)
                            setOpenPromotionDescription(!openPromotionDescription)
                    })}
                    onBlur={(() => {
                        if(neworders.point.promotionDescription)
                            setOpenPromotionDescription(false)
                    })}
                    >
                        Есть действующая акция   
                        {openPromotionDescription && 
                        <div className="order_position_footer_dropdown_container description">
                            <div className="order_position_footer_dropdown description" style={{marginTop: '5px'}} onMouseDown={((e) => e.preventDefault())}>
                                {neworders.point.promotionDescription}
                            </div>
                        </div>
                        }                     
                    </div>
                }   
                {neworders.changeLog && 
                    <button className="btn btn-secondary" onClick={onOpenModal('changeLogOrder')}>История изменений</button>
                }
                <div className="neworder_detail_information">
                    <span>Ожидание:</span>  
                    <span>{renderPointTime(neworders.point)}</span>
                </div>
                <div className="neworder_detail_information">
                        <span>
                            Предзаказ
                        </span>
                        {preOrder &&
                        <div style={{width: 'calc(100% - 90px'}}>
                            <DatePicker
                                placeholderText="Дата и время"
                                selected={neworders.visible_datetime ? new Date(neworders.visible_datetime) : null}
                                className="form-control"
                                style={{ position: 'absolute', width: '100%' }}
                                onChange={(date) => dispatch(changeInformationNewOrder('visible_datetime', date))}
                                showTimeSelect
                                timeIntervals={neworders.deliveryMethod === 'own' ? 5 : 15} 
                                dateFormat="dd/MM/yyyy HH:mm"
                                timeFormat="HH:mm"
                                locale="ru"
                                onKeyDown={(e) => e.preventDefault()}  
                                minDate={new Date()}
                                minTime={
                                    neworders.visible_datetime && new Date(neworders.visible_datetime).toDateString() === new Date().toDateString() && neworders.point
                                        ? renderTodayMinTime(neworders.point) 
                                        : neworders.deliveryMethod === 'own' ? new Date(new Date().setHours(10, 20)) : new Date(new Date().setHours(11, 0))
                                } 
                                maxTime={new Date().setHours(22, 55)} 
                            />
                        </div>}
                        <input 
                        type="checkbox"
                        checked={preOrder}
                        onChange={() => {
                            setPreOrder(!preOrder);
                            if(!preOrder)                            
                                dispatch(changeInformationNewOrder('visible_datetime', null));                            
                        }}
                        />                        
                    </div>
                {editOrder && renderSource(neworders)}
                {editOrder && neworders.userName &&
                <div className="neworder_detail_information">
                        <span>Клиент:</span>
                        {renderClient()}
                </div>
                }
                {renderTypeDeliveryMethod(neworders)}
                {renderPromocode(neworders)}
                {renderPlatformSelect(neworders)}
            </>
        );
    }

    const renderInputs = () => {
            return(
                <div className="neworder_detail_block">
                    {renderAggDataDeliveryInfo(neworders)}
                    {renderAggDataCourierInfo(neworders)}
                    <div className="neworder_detail_input_div">                        
                        <span className="neworder_detail_input_text">
                            Тел.
                        </span>
                        <input 
                            type="text"
                            inputMode="numeric"
                            className="form-control neworder phone"
                            autocomplete="false"
                            placeholder="Номер телефона"
                            value={neworders.phone ? neworders.phone : ''}
                            onChange={(e) => {
                                if (historyOrders && historyOrders.length > 0) {
                                  dispatch(clearHistoryOrders());
                                }

                                let input = e.target.value.replace(/\D/g, '');
                                
                                if (input.length === 10 && input[0] !== '7') {
                                    input = '7' + input;
                                } 

                                input = input.replace(/^[0-9]/, '7');

                                if (input.length > 11) {
                                  input = input.slice(0, 11);
                                }
                              
                                const phoneNum = input;
                              
                                dispatch(changeInformationNewOrder('phone', +phoneNum));
                              }}
                        />                        
                        {!historyHidden && 
                            <button 
                                disabled={!historyOrders || historyOrders.length <= 0 || loadingHistoryOrders} 
                                className={cn({ 'btn btn-secondary btn-icon kt-spinner--right kt-spinner--sm kt-spinner--light': true, 'kt-spinner': loadingHistoryOrders })} 
                                style={{ minHeight: '39px', minWidth: '39px' }}
                                onClick={onOpenModal('historyOrders')}
                            >
                                {!loadingHistoryOrders && <i className="flaticon-clock-1"/>}
                            </button>
                        }
                    </div>
                    {(editOrder || neworders.point) && ([idPointCC, idPointRobovoice].includes(neworders.point && neworders.point.id ? neworders.point.id : neworders.point) || neworders.deliveryMethod === 'delivery') && (!neworders.aggData || !neworders.aggData.discriminator || neworders.aggData.discriminator !== 'yandex') &&
                        <>
                            {neworders.area &&
                            <div className="neworder_detail_input_div">
                                <span className="neworder_detail_input_text">
                                    Р-н
                                </span>
                                <input 
                                    type="text"
                                    className="form-control neworder"
                                    autocomplete="false"
                                    placeholder="Район"
                                    value={`${neworders.area ? neworders.area : ''}`}
                                    onChange={((e) => dispatch(changeInformationNewOrder('area', e.target.value)))}
                                />
                            </div>
                            }
                            <div className="neworder_detail_input_div">
                                <span className="neworder_detail_input_text">
                                    Ул.
                                </span>
                                <input 
                                    type="text"
                                    className="form-control neworder"
                                    autocomplete="false"
                                    placeholder="Улица"
                                    value={`${neworders.street ? neworders.street : ''}`}
                                    onChange={((e) => dispatch(changeInformationNewOrder('street', e.target.value)))}
                                />
                            </div>
                            <div className="neworder_detail_input_div">
                                <span className="neworder_detail_input_text">
                                    Д.
                                </span>
                                <input 
                                    type="text"
                                    className="form-control neworder"
                                    autocomplete="false"
                                    placeholder="Дом"
                                    value={neworders.house ? neworders.house : ''}
                                    onChange={((e) => dispatch(changeInformationNewOrder('house', e.target.value)))}
                                />
                            </div>
                            <div className="neworder_detail_input_div">
                                <span className="neworder_detail_input_text">
                                    Под.
                                </span>
                                <input 
                                    type="text"
                                    className="form-control neworder"
                                    autocomplete="false"
                                    placeholder="Подъезд"
                                    value={neworders.entrance ? neworders.entrance : ''}
                                    onChange={((e) => dispatch(changeInformationNewOrder('entrance', e.target.value)))}
                                />
                            </div>
                            <div className="neworder_detail_input_div">
                                <span className="neworder_detail_input_text">
                                    Эт.
                                </span>
                                <input 
                                    type="text"
                                    className="form-control neworder"
                                    autocomplete="false"
                                    placeholder="Этаж"
                                    value={neworders.floor ? neworders.floor : ''}
                                    onChange={((e) => dispatch(changeInformationNewOrder('floor', e.target.value)))}
                                />
                            </div>
                            <div className="neworder_detail_input_div">
                                <span className="neworder_detail_input_text">
                                    Кв.
                                </span>
                                <input 
                                    type="text"
                                    className="form-control neworder"
                                    autocomplete="false"
                                    placeholder="Кв"
                                    value={neworders.room ? neworders.room : ''}
                                    onChange={((e) => dispatch(changeInformationNewOrder('room', e.target.value)))}
                                />
                            </div>
                        </>
                    }
                    {(editOrder || neworders.point) && <div className="neworder_detail_input_div">
                        <textarea 
                            type="text"
                            className="form-control neworder"
                            style={{minHeight: '80px', maxHeight: '80px', width: '100%'}}
                            maxLength={265}
                            autocomplete="false"
                            placeholder="Комментарий"
                            value={neworders.internalComment ? neworders.internalComment : ''}
                            onChange={((e) => dispatch(changeInformationNewOrder('internalComment', e.target.value)))}
                        />
                    </div>}
                </div>
            );
    }

    const renderPaymentMethod = () => {
        if(neworders.payment === 'online') 
            return (
            <div className="neworder_detail_block">
                <span style={{ color: '#646c9a', fontSize: '1rem'}}>Способ оплаты</span>
                <button
                className='btn btn-primary'
                style={{ height: '2rem', padding: '0.15rem 0.75rem', minWidth: '2.5rem'}}
                >
                    {getStatusPay()}
                </button>
            </div>
            );
 
        return(
            <div className="neworder_detail_block">
                <span style={{ color: '#646c9a', fontSize: '1rem'}}>Способ оплаты</span>
                <button
                className={neworders.payment === 'terminal' ? 'btn btn-primary' : 'btn btn-secondary'}
                style={{ height: '2rem', padding: '0.15rem 0.75rem', minWidth: '2.5rem'}}
                onClick={(() => dispatch(changePaymentNewOrder('terminal')))}
                >
                    Терминал
                </button>
                {(neworders.payment !== 'cash' || neworders.changeCash) &&
                <button
                className={neworders.payment === 'cash' ? 'btn btn-primary' : 'btn btn-secondary'}
                style={{ height: '2rem', padding: '0.15rem 0.75rem', minWidth: '2.5rem'}}
                onClick={(() => dispatch(changePaymentNewOrder('cash')))}
                >                    
                    {`Наличные ${neworders.changeCash ? (neworders.changeCash === 'no' ? 'без сдачи' : `сдача с ${neworders.changeCash.slice(1)} ₽`) : ''}`}
                </button>
                }
                {neworders.payment === 'cash' && !neworders.changeCash &&
                <div className="detail_order_changecash_container">
                    <div className="detail_order_changecash_buttons_div">
                        <button
                        className={neworders.changeCash === 'no' ? 'btn btn-primary' : 'btn btn-secondary'}
                        onClick={(() => dispatch(changeChangeCashNewOrder({value: 'no', sum: null })))}
                        >
                            Без сдачи
                        </button>
                        <button
                        className={neworders.changeCash === 'c1000' ? 'btn btn-primary' : 'btn btn-secondary'}
                        onClick={(() => dispatch(changeChangeCashNewOrder({ value: 'c1000', sum: 1000 })))}
                        >
                            Сдача с 1000 ₽
                        </button>
                        <button
                        className={neworders.changeCash === 'c1500' ? 'btn btn-primary' : 'btn btn-secondary'}
                        onClick={(() => dispatch(changeChangeCashNewOrder({ value: 'c1500', sum: 1500 })))}
                        >
                            Сдача с 1500 ₽
                        </button>
                    </div>
                    <div className="detail_order_changecash_buttons_div">
                        <button
                        className={neworders.changeCash === 'c2000' ? 'btn btn-primary' : 'btn btn-secondary'}
                        onClick={(() => dispatch(changeChangeCashNewOrder({ value: 'c2000', sum: 2000 })))}
                        >
                            Сдача с 2000 ₽
                        </button>
                        <button
                        className={neworders.changeCash === 'c5000' ? 'btn btn-primary' : 'btn btn-secondary'}
                        onClick={(() => dispatch(changeChangeCashNewOrder({ value: 'c5000', sum: 5000 })))}
                        >
                            Сдача с 5000 ₽
                        </button>
                    </div>
                    <div style={{ display: 'flex', gap: '5px', width: '100%'}}>
                        <input 
                        className="new_order_input"
                        style={{ width: '100%'}}
                        type="number"
                        placeholder="Другая сумма"
                        value={inputChangeCash}
                        onChange={handleInputChangeCash}
                        />
                        <button 
                        className='btn btn-secondary btn-icon'
                        style={{ padding: '0px', height: '2rem', minWidth: '2rem'}}
                        onClick={(() => {
                            if(inputChangeCash)                            
                                dispatch(changeChangeCashNewOrder({value: 'c' + inputChangeCash, sum: parseNumToFixed(inputChangeCash)}));                            
                        })}
                        >
                            <i className="flaticon2-check-mark"/>
                        </button>
                    </div>
                </div>
                }
                {payments && payments.map((payment) => (
                    <button
                    className={neworders.payment === payment.Name  ? 'btn btn-primary' : 'btn btn-secondary'}
                    style={{ height: '2rem', padding: '0.15rem 0.75rem', minWidth: '2.5rem'}}
                    onClick={(() => dispatch(changePaymentNewOrder(payment.Name)))}
                    >
                        {payment.VisibleName}
                    </button>
                ))}
            </div>
        )
    }

    const renderTagsBlock = () => {
        if(tags && tags.length > 0)
        return(
            <div className="neworder_detail_block">
                <span style={{ color: '#646c9a', fontSize: '1rem'}}>Отметки</span>
                <div className="neworder_tags_block">
                    {tags.map((tag) => (
                        <button
                        className={(neworders.tags && neworders.tags.find((el) => el.id === tag.id)) ? 'btn btn-primary' : 'btn btn-secondary'}
                        style={{ height: '2rem', padding: '0.15rem 0.75rem', minWidth: '2.5rem'}}
                        onClick={(() => 
                            dispatch(addTagNewOrder(tag))
                        )}
                        >
                            {tag.name}
                        </button>
                    ))}
                </div>
            </div>
        )
    }

    const renderInfoPoint = () => {
        return (
            <div className="order_position_footer_dropdown_container description">
                <div className="order_position_footer_dropdown description" style={{marginTop: '5px', padding: '0px'}} onMouseDown={((e) => e.preventDefault())}>
                    {neworders.point.onlinePay &&
                    <div className="neworder_comment_point"> 
                        Есть оплата ЮКасса
                    </div>
                    }
                    {neworders.point.qrPayment &&
                    <div className="neworder_comment_point">
                        Есть оплата QR
                    </div>
                    }
                    <div className="neworder_comment_point">
                        {neworders.point.deliveryToTheEntrance ? 'Доставка до подъезда' : 'Доставка до квартиры'}
                    </div>
                    {neworders.point.cafe &&
                    <div className="neworder_comment_point">
                        Работает как кафе
                    </div>
                    }               
                </div>
            </div>
        )
    }

    return(
        <div className="neworder_detail_body">
            {renderSelect()}
            {renderStatusSelect()}
            {(neworders.point || editOrder) && !loadingFilialsNewOrder && renderDeliveryMethodBlock()}
            {!loadingFilialsNewOrder && renderInputs()}
            {(neworders.point || editOrder) && !loadingFilialsNewOrder && renderPaymentMethod()}
            {(neworders.point || editOrder) && !loadingFilialsNewOrder && renderTagsBlock()}
        </div>
    );
}

export default DetailNewOrder;